export default __webpack_public_path__ + "static/media/card-poliza2.ece8b35f.png";